import { MutationCache, QueryClient, QueryKey } from '@tanstack/react-query';

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: { invalidates?: QueryKey[] };
  }
}

/**
 * Server state for the whole app. Screens read through queries, and every mutation declares which data it
 * changes (`meta.invalidates`), so all screens showing that data refetch without a page reload. Changes made
 * elsewhere (other users, the scan worker) arrive over the realtime stream -- see lib/realtime.ts.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: 1,
    },
  },
  mutationCache: new MutationCache({
    onSuccess: (_data, _variables, _context, mutation) => {
      mutation.meta?.invalidates?.forEach(queryKey => queryClient.invalidateQueries({ queryKey }));
    },
  }),
});
